export default "__VITE_ASSET__DAGEK_tK__"